export enum NavbarType {
	Utilities = 'utilities',
	Dashboard = 'dashboard',
	Admin = 'admin',
	Orders = 'orders',
	Inventory = 'inventory',
}
export enum TabType {
	NxTension = 'nxTension',
	NxOrders = 'nxOrders',
	NxInventory = 'nxInventory',
}

export const CACHE_KEY = 'quickbase_cache_key';

export const CACHE_DURATION = 24 * 60 * 60 * 1000; // 24 hours in milliseconds

// legacy: popup to Auth0, success assumed on popup close. verified: probe the QB session, silently redirect through Auth0 (IdP-initiated) when missing. Per-tenant via the `authReturnPage` integration param.
export type QuickbaseAuthFlow = 'legacy' | 'verified';

export const QB_AUTH_BOUNCE_AT_KEY = 'quickbase_auth_bounce_at';
export const QB_AUTH_BOUNCE_COOLDOWN_MS = 5 * 60 * 1000;
export const QB_AUTH_TIMEOUT_MS = 5 * 60 * 1000;

export const QB_EMBED_MESSAGE_TYPE = 'qb-embed';
export const QB_EMBED_PROBE_TIMEOUT_MS = 10 * 1000;
export const QB_EMBED_PROBE_GRACE_MS = 1500;
